import * as yup from "yup";

const REFINANCE_LOAN_TYPE = process.env.NEXT_PUBLIC_REFINANCE_LOAN_TYPE;
const CONSTRUCTION_LOAN_TYPE = process.env.NEXT_PUBLIC_CONSTRUCTION_LOAN_TYPE;

const optionalCurrency = yup
  .number()
  .transform(v => (Number.isNaN(v) ? undefined : v))
  .nullable()
  .default(0);

const requiredCurrency = yup
  .number()
  .transform(v => (Number.isNaN(v) ? 0 : v))
  .default(0)
  .required("This field is required")
  .min(0, "Must be zero or greater");

const isConstructionType = val => String(val) === CONSTRUCTION_LOAN_TYPE;

const dealSummaryValidation = yup.object().shape({
  loanTypeId: yup.string().required("This field is required"),
  propertyTypeId: yup.string().required("This field is required"),
  units: yup
    .number()
    .transform(v => (Number.isNaN(v) ? undefined : v))
    .nullable(),
  propertyUseTypeId: yup.string().required("This field is required"),
  countryId: yup.string().required("This field is required"),
  stateId: yup.string().required("This field is required"),
  address: yup.string().required("This field is required"),
  amount: yup
    .number()
    .transform(v => (Number.isNaN(v) ? undefined : v))
    .moreThan(0, "Loan Amount must be greater than $0.00")
    .required("This field is required."),
  estimatedValue: yup
    .number()
    .transform(v => (Number.isNaN(v) ? undefined : v))
    .required("This field is required")
    .moreThan(yup.ref("amount"), "Estimated Value must be greater than Loan Amount"),
  cashOutAmount: yup.number().when("loanTypeId", {
    is: val => val === REFINANCE_LOAN_TYPE,
    then: () => requiredCurrency,
    otherwise: () => optionalCurrency,
  }),
  landCost: yup.number().when("loanTypeId", {
    is: isConstructionType,
    then: () => requiredCurrency,
    otherwise: () => optionalCurrency,
  }),
  totalSoftCostSpent: yup.number().when("loanTypeId", {
    is: isConstructionType,
    then: () => requiredCurrency,
    otherwise: () => optionalCurrency,
  }),
  totalHardCostSpent: yup.number().when("loanTypeId", {
    is: isConstructionType,
    then: () => requiredCurrency,
    otherwise: () => optionalCurrency,
  }),
  additionalInvestorEquity: yup.number().when("loanTypeId", {
    is: isConstructionType,
    then: () => requiredCurrency,
    otherwise: () => optionalCurrency,
  }),
});

export default dealSummaryValidation;

